/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";
import Stack from "@mui/material/Stack";
import { Button, Grid, IconButton, Typography } from "@mui/material";
import { Card, CardContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import Div from "@jumbo/shared/Div";
import Loader from "@jumbo/components/Loader";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import { useDispatch, useSelector } from "react-redux";
import {
  markModuleRead,
  fetchUnreadCount,
} from "app/redux/slice/notificationSlice";
import { useSnackbar } from "notistack";
import { userType } from "app/helpers/userType";
import { getSupplierList } from "app/redux/slice/supplierSlice";
import { getProductList } from "app/redux/slice/productSlice";
import { getUserList } from "app/redux/slice/userSlice";
import {
  createPartyRate,
  deletePartyRate,
  getPartyRateList,
  updatePartyRate,
} from "app/redux/slice/partyRateSlice";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";
import UpdatePartyRate from "./update-party-rate";
import ImportPartyRate from "./import-party-rate";
import {
  PARTY_RATE_ADD,
  PARTY_RATE_PRODUCT_WISE,
} from "app/routes/constant";
import { useNavigate } from "react-router-dom";

const PartyRate = () => {
  const { isOpen, onClose, stageAction, actionProps } = useDisclosure();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { isMA } = userType();
  const partyRateData = useSelector((state) => state?.partyRate);
  const productData = useSelector((state) => state?.product);
  const supplierData = useSelector((state) => state?.supplier);
  const userData = useSelector((state) => state?.user);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [productId, setProductId] = useState();
  const [supplierId, setSupplierId] = useState();
  const [userId, setUserId] = useState();

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();

  const {
    isOpen: isImportOpen,
    onClose: closeImport,
    onOpen: openImport,
  } = useDisclosure();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "partyRate" });
  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission")),
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
    deletePermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
        deletePermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
        deletePermission: false,
      };
      permissionData?.length &&
        permissionData.forEach(function (num) {
          if (num?.name === "create-supplier-rate") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "delete-supplier-rate") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "update-supplier-rate") {
            permissionValue.updatePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const columns = [
    {
      id: "product",
      label: "Product",
      sort: true,
      render: (row) => row?.product?.name || row?.productName,
    },
    {
      id: "supplier",
      label: "Supplier",
      sort: true,
      render: (row) => row?.supplier?.name || row?.supplierName,
    },
    {
      id: "belongsTo",
      label: "Belongs To",
      sort: false,
      render: (row) => row?.supplier?.user?.name || "-",
    },
    { id: "mobileNumber", label: "Mobile No", sort: true },
    { id: "gst", label: "GST", sort: true },
    { id: "price", label: "Price", sort: true },
    {
      id: "actions",
      label: "Actions",
      minWidth: 130,
      align: "center",
      render: (row) => (
        <>
          <IconButton
            disabled={!permission.updatePermission}
            onClick={() => {
              stageAction(row);
            }}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            disabled={!permission.deletePermission}
            onClick={() => {
              deleteStageAction(row);
            }}
          >
            <DeleteIcon color={"error"} />
          </IconButton>
        </>
      ),
    },
  ];

  const handleSubmit = async (data) => {
    const newPartyRateData = {
      productId: data?.productId?._id || data?.productId,
      supplierId: data?.supplierId?._id || data?.supplierId,
      gst: data?.gst?.trim()?.toUpperCase() || "",
      price: Number(data?.price),
      mobileNumber: data?.mobileNumber,
    };

    const response = await dispatch(
      actionProps?._id
        ? updatePartyRate({ id: actionProps._id, data: newPartyRateData })
        : createPartyRate(newPartyRateData),
    ).unwrap();
    if (response.status === 200) {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "success",
      });
      getData();
      onClose();
    } else {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "error",
      });
    }
  };

  const deletePartyRateHandler = () => {
    dispatch(deletePartyRate(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const getData = () => {
    const value = {
      page: page,
      perPage: rowsPerPage,
      ...(supplierId && { supplierId: supplierId._id }),
      ...(productId && { productId: productId._id }),
      ...(userId && { userId: userId._id }),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getPartyRateList(value));
    dispatch(markModuleRead("SupplierRate")).then(() => {
      dispatch(fetchUnreadCount("SupplierRate"));
    });
  };

  // Refreshing only once the import dialog is dismissed keeps its summary
  // readable - reloading the list swaps this whole page for a <Loader />, which
  // would unmount the dialog mid-read.
  const handleImportClose = () => {
    closeImport();
    getData();
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  useEffect(() => {
    dispatch(getProductList({ field: "name", sort: 1 }));
    dispatch(getSupplierList({ sort: 1, field: "name" }));
    dispatch(getUserList({ field: "name", sort: 1 }));
  }, []);

  useEffect(() => {
    getPermission();
  }, []);

  return (
    <>
      {partyRateData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={3.5}>
                    <JumboAutoComplete
                      options={productData?.list || []}
                      label="Product"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`productId`}
                      value={productId}
                      onChange={(evt, value) => setProductId(value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3.5}>
                    <JumboAutoComplete
                      options={supplierData?.list || []}
                      label="Party"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`supplierId`}
                      value={supplierId}
                      onChange={(evt, value) => setSupplierId(value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <JumboAutoComplete
                      options={userData?.list || []}
                      label="Belongs To"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`userId`}
                      value={userId}
                      onChange={(evt, value) => setUserId(value)}
                      isOptionEqualToValue={(option, value) =>
                        option?._id === value?._id
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Party Rate List
                </Typography>
                {permission.createPermission && (
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ mt: { xs: 1, md: 0 } }}
                  >
                    <LoadingButton
                      onClick={() => navigate(PARTY_RATE_PRODUCT_WISE)}
                      variant="outlined"
                      startIcon={<PriceChangeIcon />}
                    >
                      Product Wise Price
                    </LoadingButton>
                    <LoadingButton
                      onClick={openImport}
                      variant="outlined"
                      startIcon={<CloudUploadIcon />}
                    >
                      Import
                    </LoadingButton>
                    <LoadingButton
                      onClick={() => {
                        navigate(PARTY_RATE_ADD);
                      }}
                      type="submit"
                      variant="contained"
                    >
                      Add Party Rate
                    </LoadingButton>
                  </Stack>
                )}
              </Stack>
              <Table
                columns={columns}
                rows={partyRateData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={partyRateData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          <DialogDefault
            open={isOpen}
            onClose={onClose}
            content={
              <UpdatePartyRate
                value={actionProps}
                onClose={onClose}
                handleSubmit={handleSubmit}
              />
            }
            title={actionProps?._id ? "Update Party Rate" : "Add Party Rate"}
            fullWidth={true}
            maxWidth={"md"}
            actions={<></>}
          />
          <DialogDefault
            open={isImportOpen}
            onClose={handleImportClose}
            content={<ImportPartyRate onClose={handleImportClose} />}
            title="Import Party Rate"
            fullWidth={true}
            maxWidth={"sm"}
            actions={<></>}
          />
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the party rate?"
            onConfirm={deletePartyRateHandler}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
        </>
      )}
    </>
  );
};

export default PartyRate;
